import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Lock, Loader2 } from "lucide-react";
import LogoIcon from "@/components/LogoIcon";
import { toast } from "sonner";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (localStorage.getItem("gp_token")) {
    return <Navigate to="/admin" replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("gp_token", data.token);
      localStorage.setItem("gp_admin_email", data.email);
      navigate("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Credenciais inválidas");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-6 py-12 bg-gp-gradient-light">
      <form onSubmit={submit} className="w-full max-w-md card-soft p-8 sm:p-10" data-testid="admin-login-form">
        <div className="text-center mb-8">
          <div className="w-14 h-14 rounded-2xl bg-gp-gradient mx-auto flex items-center justify-center mb-4 shadow-lg">
            <LogoIcon className="w-7 h-7" fill="white" />
          </div>
          <div className="text-xs uppercase tracking-widest font-quicksand font-bold text-[#1BB0CE]">
            ACESSO RESTRITO
          </div>
          <h1 className="font-quicksand text-2xl font-extrabold text-[#3d3d3d] mt-1">Painel da Loja</h1>
        </div>

        <label className="block mb-5">
          <span className="text-xs font-quicksand font-bold text-[#3d3d3d]">E-mail</span>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="admin-email-input" className="input-gp mt-2" />
        </label>
        <label className="block mb-8">
          <span className="text-xs font-quicksand font-bold text-[#3d3d3d]">Senha</span>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="admin-password-input" className="input-gp mt-2" />
        </label>
        <button type="submit" disabled={loading} data-testid="admin-login-button" className="btn-gp w-full">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Lock className="w-4 h-4" />}
          {loading ? "ENTRANDO..." : "ENTRAR"}
        </button>
      </form>
    </div>
  );
}
